import { maskJSON2, JsonMask2Configs } from "maskdata";
export default class LoggerMasker {
  private static options: JsonMask2Configs = {
    passwordMaskOptions: {
      maskWith: "*",
    },
    passwordFields: ["password"],
  };

  static maskValues<T extends object>(data: T): T {
    return maskJSON2({ ...data }, LoggerMasker.options);
  }
}
